import { Separator } from '@hub-la/shadcn'
import { memo } from 'react'
import { PaymentMethod } from '../../../domain/enums/payment-method'
import { useGetCoupon } from '../../hooks/use-get-coupon'
import { useGetOffers } from '../../hooks/use-get-offers'
import { Description } from './description'
import { Details } from './details'
import { Header } from './header'
import { Loading } from './loading'

type CouponDetailProps = {
  id: string
  onClose: () => void
  /** @todo This is temporary, since this is a modal and we shouldn't refetch offers */
}

export const CouponDetail = memo(({ id, onClose }: CouponDetailProps) => {
  const { data: offers = [] } = useGetOffers()
  const { data: coupon } = useGetCoupon(id)

  if (!coupon) {
    return <Loading />
  }

  return (
    <div className="h-full w-full overflow-auto">
      <div className="space-y-4 mb-8">
        <Header code={coupon.code} status={coupon.state} id={coupon.id} onClose={onClose} offers={offers} />
        <Separator />
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
          <div className="col-span-1 lg:col-span-7 space-y-6">
            <Description
              discount={coupon.discountPercent}
              usagesCount={coupon.usagesCount}
              maxAllowedTotalUsages={coupon.maxAllowedTotalUsages}
              appliableTo={coupon.appliableTo}
              isRecurrent={coupon.isRecurrent}
              paymentMethods={[PaymentMethod.CREDIT_CARD, PaymentMethod.PIX, PaymentMethod.BOLETO]}
            />
          </div>

          <div className="col-span-1 lg:col-span-5 space-y-6">
            <Details id={coupon.id} createdAt={coupon.createdAt} validUntil={coupon.validUntil} />
          </div>
        </div>
      </div>
    </div>
  )
})
